"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _useOurTranslation = _interopRequireDefault(require("../../utils/useOurTranslation"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var LegalFooter = function LegalFooter(_ref) {
  var applicationRoutes = _ref.applicationRoutes,
      outerStyle = _ref.outerStyle;
  var t = (0, _useOurTranslation.default)("profile-components:Funnel");
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _styleModule.default.legalFooter,
    style: outerStyle,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: applicationRoutes === null || applicationRoutes === void 0 ? void 0 : applicationRoutes.lpImprint,
        children: t('Footer.imprint')
      }), "\xA0|\xA0", /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: applicationRoutes === null || applicationRoutes === void 0 ? void 0 : applicationRoutes.lpTerms,
        children: t('Footer.agb')
      }), "\xA0|\xA0", /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: applicationRoutes === null || applicationRoutes === void 0 ? void 0 : applicationRoutes.lpPrivacy,
        children: t('Footer.privacy')
      })]
    })
  });
};

var _default = /*#__PURE__*/_react.default.memo(LegalFooter);

exports.default = _default;